module.exports = __webpack_public_path__ + "img/lod.2ec8d44d.gif";